<template>
  <div class="car-number-widget-container" :style="getContainerStyle">
    <p
      :class="[options.theme, 'car-number-item']"
      :style="getStyle(index, current)"
      v-for="(item, index) in 8"
      :key="index"
    >
      {{ index == 7 ? '新能源' : '' }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'carNumberWidget',
  props: ['options'],
  data() {
    return {
      current: 0,
    }
  },
  computed: {
    getMarginNumber() {
      return -(this.options.boxMargin + 4 + 2) / 2 + 'px'
    },
    getSelectBorderColor() {
      return this.options.selectBorderColor
    },
    getStyle() {
      return (index, current) => {
        let style = null
        const {
          boxWidth,
          boxHeight,
          boxMargin,
          borderRadius,
          textSize,
          textColor,
          borderColor,
          backgroundColor,
          newEnergyFontSize,
          newEnergyColor,
          selectBorderColor,
          theme,
        } = this.options
        style = {
          width: boxWidth + 'px',
          height: boxHeight + 'px',
          margin: `0 ${boxMargin}px 0 0`,
          'font-size': `${index === 7 ? newEnergyFontSize : textSize}px`,
          color: index === 7 ? newEnergyColor : textColor,
          'background-color': backgroundColor,
        }
        if (theme === 'block') {
          style = {
            ...style,
            'border-radius': borderRadius,
            border: `1px solid ${
              index === 7
                ? newEnergyColor
                : index === current
                  ? selectBorderColor
                  : borderColor
            }`,
          }
        }
        return style
      }
    },
    getContainerStyle() {
      const { borderColor, theme, backgroundColor } = this.options
      let style = {
        width: 'fit-content',
        border: `1px solid ${borderColor}`,
        'background-color': backgroundColor,
      }
      return theme === 'line' ? style : ''
    },
  },
}
</script>
<style lang="scss" scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.car-number-widget-container {
  display: flex;

  .car-number-item {
    display: flex;
    align-items: center;
    justify-content: center;
    &.line {
      position: relative;
      &:after {
        content: '';
        width: 1px;
        height: 50%;
        position: absolute;
        right: 0;
        top: 25%;
        background-color: #d9d9d9;
        -webkit-transform: scaleX(0.5);
        transform: scaleX(0.5);
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
      &:nth-child(3) {
        &::before {
          display: none;
        }
      }
    }
    &:nth-child(3) {
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: v-bind(getSelectBorderColor);
        margin: auto;
        left: v-bind(getMarginNumber);
      }
    }
  }
}
</style>
